// @ts-nocheck
import { useState, useCallback } from "react";
import queryString from "query-string";
import { useMemo } from "react";

const baseURL =
  process.env.REACT_APP_API_URL || "https://buy.bigbenespana.es/restapi/api";

const checkStatus = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  if (response.status === 401) {
    localStorage.removeItem("token");
    window.location.reload();
  }
  const error = new Error(response.statusText);
  // @ts-ignore
  error.response = await response.json();
  throw error;
};

const parseJSON = (response) => {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
};

const emptyObject = {};
const voidFunction = () => {};

export default function useLazyQuery({
  url = "",
  options = emptyObject,
  onCompleted = voidFunction,
  onError = voidFunction,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [data, setData] = useState(undefined);

  const fetchOptions = useMemo(
    () => ({
      method: "GET",
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }),
    [options]
  );

  const fetchData = useCallback(
    async (queryParams = {}, extendedUrl = "") => {
      setError(undefined);
      setLoading(true);
      try {
        const response = await fetch(
          queryString.stringifyUrl({
            url: `${baseURL}${url}${extendedUrl}`,
            query: queryParams,
          }),
          fetchOptions
        )
          .then(checkStatus)
          .then(parseJSON);

        setData(response);
        setLoading(false);
        onCompleted(response);
      } catch (err) {
        const message = err.response ? err.response.message : err.message;
        setError(message);
        setLoading(false);
        onError(message);
      }
    },
    [url, fetchOptions, onCompleted, onError]
  );

  return [fetchData, { data, loading, error }, () => setData(undefined)];
}
